import React, { Component } from "react";

class BtnCellRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apiUrl: props.apiUrl,
      notification_status: props.status,
      app_token: props.app_token,
      attribute_set_key: props.attribute_set_key,
      event_id: props.event_id,
      notification_tag_code: props.notification_tag_code,
      status: false,
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  async componentDidMount() {
    if (this.state.notification_status === 1) {
      this.setState({
        status: true,
      });
    } else if (this.state.notification_status === 0) {
      this.setState({
        status: false,
      });
    }
  }

  handleUpdate() {
    fetch(this.state.apiUrl + "changeStatus", {
      method: "post",
      body: JSON.stringify({
        app_token: this.state.app_token,
        attribute_set_key: this.state.attribute_set_key,
        notification_tag_code: this.state.notification_tag_code,
        notification_status: this.state.notification_status === 0 ? 1 : 0,
        event_id: this.state.event_id,
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        console.log("Notifications Status: ", result);
        this.props.NotificationMessage(result);
      });
  }

  handleToggle() {
    if (this.state.notification_status === 1 && this.state.status === true) {
      this.setState({
        status: false,
        notification_status: 0,
      });
      console.log("Notification In-Active");
    } else if (
      this.state.notification_status === 0 &&
      this.state.status === false
    ) {
      this.setState({
        status: true,
        notification_status: 1,
      });
      console.log("Notification Active");
    }
    this.handleUpdate();
  }

  render() {
    return (
      <div class="form-check form-switch notification-form-switch">
        <input
          class="form-check-input"
          type="checkbox"
          role="switch"
          id="flexSwitchCheckChecked"
          onChange={this.handleToggle}
          checked={this.state.status}
        />
      </div>
    );
  }
}

export default BtnCellRenderer;
